import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../common/button/Button';
import Typography from '../common/typography/Typography';
import VideoPlayer from '../media/VideoPlayer';
import { MainSection, MainFrame, GradientWrap } from '../../styles/LandingStyles';
import { BackgroundContainer } from '../../styles/CommonStyles';

import useLanguagePack from '../../hooks/useLanguagePack';
import useVideoOptions from '../../hooks/useVideoOptions';

import { checkIsMobile } from '../../utils';
import { MAIN_VOD_URL, MAIN_VOD_THUMBNAIL } from '../../constants/background';

const Section1 = () => {
  const navigate = useNavigate();

  const [option] = useVideoOptions(MAIN_VOD_THUMBNAIL, MAIN_VOD_URL);

  const languageKeyStrings = {
    title: useLanguagePack('landing_main_title_1'),
    text: useLanguagePack('renew_landing_1'),
    buttonLabel: useLanguagePack('landing_main_cta_button_label_1'),
    goToSign: useLanguagePack('gotosignin_text_1'),
    goToSignButton: useLanguagePack('gotosignin_textlink_1'),
    buttonText: useLanguagePack('renew_landing_2'),
  };

  return (
    <MainSection isMobileUA={checkIsMobile()}>
      {!checkIsMobile() && <VideoPlayer src={MAIN_VOD_URL} type={'video/mp4'} {...option} />}
      <GradientWrap />
      <BackgroundContainer
        isMobileUA={checkIsMobile()}
        backgroundImage={MAIN_VOD_THUMBNAIL}
        backgroundPositionX={346}
        backgroundPositionY={0}
      >
        <MainFrame>
          <Typography variant={'H2'}>{languageKeyStrings.title}</Typography>
          <Typography variant={'C1'}>{languageKeyStrings.text}</Typography>
          <Button
            onClick={() => navigate('/signup')}
            color='primary'
            variant='contained'
            size='md'
            style={{ marginTop: 40, marginBottom: 16,}}
          >
            {languageKeyStrings.buttonText}
          </Button>
          <div
            style={{
              display: 'flex',
              gap: '16px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant={'C2'}>{languageKeyStrings.goToSign}</Typography>
            <Typography variant={'L1'} onClick={() => navigate('/signin')} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
              {languageKeyStrings.goToSignButton}
            </Typography>
          </div>
        </MainFrame>
      </BackgroundContainer>
      {/* <CoachMarkScroll>
        <ScrollDown />
        <Typography variant={'C2'}>
          {languagePack.find(l => l.lang_code === 'landing_coachmark_scroll_1')[language]}
        </Typography>
      </CoachMarkScroll> */}
      {/* <ArtistName>
        landing_vid
        <br />
        KEYCUT Original
      </ArtistName> */}
    </MainSection>
  );
};

export default Section1;
